import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import format from 'date-fns/format';
import * as queryString from "query-string";
import { useLocation } from "react-router";
import SearchCarWidget from "../components/SearchCarWidget";
import routes from '../constants/routes.json';
import { DEFAULT_FILTERS, DEFAULT_AGE } from '../constants/default';
import { useTranslation } from 'react-i18next';
import MyHelmet from '../components/MyHelmet';

function WidgetOnly({ dir, cur, residency }) {
  const location = useLocation();
  const [params, setParams] = useState();
  const { t, i18n } = useTranslation(); // eslint-disable-line
  const lng = i18n.language

  useEffect(() => {
    const params = queryString.parse(location.search);
    const { endDate, startDate, fromLocationCode, toLocationCode, age, title, subtitle, btnBgColor, btnBorderColor, widgetBgColor, btnTextColor, utm_campaign, ...rest } = params;
    setParams({ endDate, startDate, fromLocationCode, toLocationCode, age, title, subtitle, btnBgColor, btnBorderColor, widgetBgColor, btnTextColor, utm_campaign});
  }, []); // eslint-disable-line

  const onSubmit = fields => {
    const searchParams = {
      startDate: `${format(fields.startDate, 'dd/MM/yyyy')}T${fields.hoursFrom}:${fields.minsFrom}`,
      endDate: `${format(fields.endDate, 'dd/MM/yyyy')}T${fields.hoursTo}:${fields.minsTo}`,
      fromLocationCode: fields.fromLocation.locationCode,
      toLocationCode: fields.toLocation.locationCode,
      age: fields.age || DEFAULT_AGE,
      lng: lng,
      ...DEFAULT_FILTERS,
    };
    if (fields.residency) {
      searchParams.residency = fields.residency;
    }
    if (cur) {
      searchParams.cur = cur;
    }

    if (params.utm_campaign) {
      searchParams.utm_campaign = params.utm_campaign
    }

    const url = 'https://search.paapmpaapm.com/' + routes.SEARCH + '?' + queryString.stringify(searchParams);
    const win = window.open(url, '_blank');
    if (win != null) {
      win.focus();
    }
  };

  return (
    <>
      <MyHelmet lng={lng} />
      <SearchCarWidget dir={dir} onSubmit={onSubmit} params={params} minimized={false} allowTitleOverride={true} forcePortal={true} showTitles={true} residency={residency} />
    </>
  );
}

const mapStateToProps = ({ ui, prefs }) => ({
  dir: ui.direction,
  cur: prefs.cur,
  residency: prefs.residency,
});

export default connect(mapStateToProps)(WidgetOnly);
